<template>
  <div>
    <b-field v-if="multiSelect" class="mb-3" grouped group-multiline>
      <b-field v-for="(lang, key) in langList" :key="lang.name">
        <b-button @click="removeMultiLang(key)">
          <div class="level">
            <b>{{ lang.iso1 || lang.iso }}</b>
            <span class="ml-2">
              {{ lang.name }}
            </span>
          </div>
        </b-button>
      </b-field>
    </b-field>

    <b-autocomplete
      v-model="langInput"
      :data="avLangFilter"
      field="name"
      :keep-first="true"
      :open-on-focus="true"
      :placeholder="$t('selectALang')"
      :loading="loading"
      :disabled="disabled"
      :clear-on-select="multiSelect"
      @select="selection"
    >
      <template slot-scope="props">
        <div class="media">
          <div class="media-content">
            {{ props.option.name }}
            <br />
            <small>
              <span v-if="typeof props.option.native == 'string'">
                <b v-for="(native, key) in props.option.native.split(';')" :key="key"> {{ native }} - </b></span
              >
              <span v-if="typeof props.option.iso == 'string'"
                ><b>{{ props.option.iso.toUpperCase() }}</b></span
              >
              <span v-if="typeof props.option.iso1 == 'string'"
                ><b> - {{ props.option.iso1.toUpperCase() }}</b></span
              >
            </small>
          </div>
        </div>
      </template>
    </b-autocomplete>
  </div>
</template>

<script>
import iso from "@/iso-langs";

export default {
  name: "LanguagePicker",
  props: {
    value: {
      type: String,
      default: "",
    },
    whitelist: {
      type: Array,
      default: null,
    },
    blacklist: {
      type: Array,
      default: null,
    },
    changeLocal: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    langList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      langInput: "",
    };
  },
  computed: {
    avLangs() {
      return Object.values(
        Object.fromEntries(
          Object.entries(iso).filter(
            (x) =>
              x[0] != x[1]["639-2/B"] &&
              (this.whitelist == null || this.whitelist.includes(x[0])) &&
              (this.blacklist == null || !this.blacklist.includes(x[0])),
          ),
        ),
      )
        .map((lang) => ({
          iso: lang["639-2"],
          iso1: lang["639-1"],
          native: lang["native"],
          name: lang.en[0],
          de: lang.de[0],
        }))
        .sort((a, b) => {
          var at = a.name.toUpperCase();
          var bt = b.name.toUpperCase();
          return at < bt ? -1 : at > bt ? 1 : 0;
        });
    },
    avLangFilter() {
      let filterList = [];

      this.avLangs.forEach((lang) => {
        if (lang.iso1 && lang.iso1.toString().toLowerCase() == this.langInput.toLowerCase().trim()) {
          filterList.push(filterList[0]);
          filterList[0] = lang;
        } else if (lang.iso && lang.iso.toString().toLowerCase() == this.langInput.toLowerCase().trim()) {
          filterList.push(filterList[0]);
          filterList[0] = lang;
        } else if (lang.name.toString().toLowerCase().indexOf(this.langInput.toLowerCase()) >= 0) {
          filterList.push(lang);
        } else if (
          lang.native &&
          lang.native
            .toString()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .indexOf(
              this.langInput
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""),
            ) >= 0
        ) {
          filterList.push(lang);
        } else if (
          lang.de &&
          lang.de
            .toString()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .indexOf(
              this.langInput
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""),
            ) >= 0
        ) {
          filterList.push(lang);
        }
      });

      return filterList;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        let fittingLang = this.avLangs.find((lang) => lang.iso == val);
        if (fittingLang && !this.multiSelect) {
          this.langInput = fittingLang.name || fittingLang.iso;
        }
      },
    },
  },
  methods: {
    selection(selection) {
      if (selection === null) {
        // unset language
        this.$emit("input", "");
      } else {
        // set language
        this.$emit("input", selection.iso);
        // add lang to multiselect view
        if (this.langList) {
          if (!this.langList.map((y) => y.iso).includes(selection.iso) && this.multiSelect) {
            this.langList.push(selection);
            this.$emit("multiSelect", this.langList); // Handle this Event to get the list of languages
          }
        }
        // set frontend internationalization language
        if (this.changeLocal && this.$i18n.availableLocales.includes(iso[selection.iso]["639-1"])) {
          this.$i18n.locale = iso[selection.iso]["639-1"];
        } else if (this.changeLocal) {
          this.$i18n.locale = "en";
        }
      }
    },
    removeMultiLang(key) {
      this.langList.splice(key, 1);
    },
  },
};
</script>

<style scoped>
.field:not(:last-child) {
  margin-bottom: 0;
}
</style>
